import React, { useEffect, useState } from "react";
import { fetchData } from "../api";
import Header from "../Components/GlobalComponent/Header";
import Footer from "../Components/GlobalComponent/Footer";
import BannerBg from "../images/banner-bg.png";

const AlgemeneVoorwaarden = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadContent = async () => {
      try {
        setLoading(true);
        const content = await fetchData("algemene-voorwaarden-page", true);
        setData(content);
      } catch (err) {
        console.error("Error loading content:", err);
        setError("Failed to load content");
      } finally {
        setLoading(false);
      }
    };

    loadContent();
  }, []);

  if (loading) {
    return (
      <div>
        <Header />
        <main className="container py-20 min-h-[60vh] flex items-center justify-center">
          <div className="animate-spin rounded-full h-32 w-32 border-b-2 border-[#286766]"></div>
        </main>
        <Footer />
      </div>
    );
  }

  if (error || !data) {
    return (
      <div>
        <Header />
        <main className="container py-20 min-h-[60vh] flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-4xl font-bold text-gray-800 mb-4">Content Not Available</h1>
            <p className="text-gray-600">The content could not be loaded at this time.</p>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Header />
      
      {/* Hero Section - New Paradigm */}
      <section className="relative bg-gradient-to-r from-[#286766] to-[#27352C] py-20">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="container relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="text-center lg:text-left">
              <h1 className="text-4xl lg:text-5xl font-bold text-white mb-6 leading-tight">
                {data.Title || "Algemene Voorwaarden"}
              </h1>
              <p className="text-xl text-white/90 leading-relaxed">
                {data.Description ? (data.Description.length > 120 ? data.Description.slice(0, 120) + '...' : data.Description) : "Lees hier onze algemene voorwaarden en de voorwaarden waaronder wij onze diensten verlenen."}
              </p>
            </div>
            <div className="flex justify-center lg:justify-end">
              <div className="relative">
                <img 
                  src={BannerBg} 
                  alt="Algemene Voorwaarden" 
                  className="w-full max-w-md h-80 object-cover rounded-2xl shadow-2xl"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-2xl"></div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Content Section */}
      <section className="py-20 bg-white">
        <div className="container">
          <div className="max-w-6xl mx-auto">
            <div className="bg-gray-100 rounded-lg shadow-lg overflow-hidden">
              <iframe
                src="/Algemene voorwaarden.pdf"
                className="w-full h-[800px] border-0"
                title="Algemene Voorwaarden PDF"
              />
            </div>
          </div>
        </div>
      </section>
      
      <Footer />
    </div>
  );
};

export default AlgemeneVoorwaarden; 